import React from 'react';
import { Card } from '../ui/card';
import { Button } from '../ui/button';
import { AlertCircle } from 'lucide-react';

const CancellationDialog = ({ 
  cancellationReason, 
  setCancellationReason, 
  cancelling, 
  onCancel, 
  onClose 
}) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <Card className="p-6 max-w-md w-full mx-4">
        <div className="space-y-4">
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center">
              <AlertCircle className="h-6 w-6 text-red-600" />
            </div>
            <div>
              <h2 className="text-xl font-bold text-gray-900">Cancel Ride</h2>
              <p className="text-sm text-gray-600">
                Please select a reason for cancellation
              </p>
            </div>
          </div>

          <div className="bg-yellow-50 p-3 rounded-lg border border-yellow-200">
            <p className="text-sm text-yellow-800">
              ⚠️ You can cancel up to 3 rides per week. Exceeding this limit will result in a 7-day suspension.
            </p>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Cancellation Reason *
            </label>
            <select
              value={cancellationReason}
              onChange={(e) => setCancellationReason(e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent"
              autoFocus
            >
              <option value="">Select a reason</option>
              <option value="passenger_not_showing">Passenger not showing up</option>
              <option value="wrong_location">Wrong pickup location</option>
              <option value="unsafe_situation">Unsafe situation</option>
              <option value="vehicle_breakdown">Vehicle breakdown</option>
              <option value="emergency">Emergency</option>
              <option value="other">Other reason</option>
            </select>
          </div>

          <div className="flex gap-3">
            <Button
              onClick={onClose}
              variant="outline"
              className="flex-1"
              disabled={cancelling}
            >
              Go Back
            </Button>
            <Button
              onClick={onCancel}
              className="flex-1 bg-red-600 hover:bg-red-700"
              disabled={cancelling || !cancellationReason}
            >
              {cancelling ? 'Cancelling...' : 'Confirm Cancellation'}
            </Button>
          </div>
        </div>
      </Card>
    </div>
  );
};

export default CancellationDialog;
